import React from "react"

const GAHiddenInputs = () => {
  return (
    <>
      <input type="hidden" id="form_cid" name="form_cid" defaultValue="" />
      <input type="hidden" id="form_sid" name="form_sid" defaultValue="" />
    </>
  );
};

export default GAHiddenInputs;